import { render, staticRenderFns } from "./SportResults.vue?vue&type=template&id=467f0d4f"
import script from "./SportResults.vue?vue&type=script&lang=js"
export * from "./SportResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports